import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Route guard.
 * - Requires authentication (redirects to `loginPath`).
 * - If `allowedRoles` is provided and the user's role is not included,
 *   redirects to `redirect` (used to keep customers out of the staff portal
 *   and vice-versa).
 */
export const ProtectedRoute = ({
  children,
  allowedRoles = null,
  loginPath = "/portal/login",
  redirect = "/",
}) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
        <div className="animate-pulse text-sm">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to={redirect} replace />;
  }

  return children;
};

export default ProtectedRoute;
